<template>
	<h2 class="font-bold text-3xl leading-10 mb-4 text-surface-800 dark:text-surface-100">
		<slot>{{ title }}</slot>
	</h2>
</template>

<script>
export default {
	name: "PageHeading",
	props: {
		title: String,
	},
}
</script>